import { useState } from "react"
import { useNavigate } from "react-router-dom"
import useListUser from "./useListUser"
import DeleteModal from "../../../../components/modal/DeleteModal"
import PaginationComponent from "../../../../components/pagination/PaginationComponent"
import { BsPencilSquare, BsFillTrashFill } from "react-icons/bs"
import { MdOutlinePassword } from "react-icons/md"
import { Input, Select } from "antd"
import Loading from "../../../../components/loading/Loading"
import { SearchOutlined } from "@ant-design/icons"
import ActionButtonGradient from "../../../../components/button/ActionButtonGradient"

const ListUser = ({ hideCreateButton = false }) => {
    const navigate = useNavigate()
    const {
        payload,
        getUsers,
        fileInputKey, 
        handleFileChange,
        postBulkUser,
        page, 
        changePage,
        totalPage,
        generatePassword,
        deleteUser,
        setFilterNameUser,
        setFilterLimit,
        logs,
        loadingPagestate,
        postBulkPassword,
    } = useListUser()
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [deleteID, setDeleteID] = useState()
    const [userName, setName] = useState()
    const [limitOptions, setLimitOptions] = useState([
        {'label': 10, 'value':10},
        {'label': 25, 'value':25},
        {'label': 50, 'value':50},
        {'label': 100, 'value':100},
    ])

    return(
        <div>
            <Loading state={loadingPagestate}/>
            {!hideCreateButton && (
                <div className="d-flex">
                    <button className="btn btn-primary add-button" onClick={() => navigate('/user-management/user-form')}>
                        Create User
                    </button>
                </div>
            )}
            <div className="d-flex gap-3">
                <div style={{ flex: 1 }}>
                    <h6 style={{ fontWeight: 600, fontSize: '14px', marginBottom: '12px' }}>Bulk Insert User Data</h6>
                    <form onSubmit={(e) => {
                        e.preventDefault()
                        postBulkUser(() => getUsers(page))
                    }}>
                        <input
                            key={fileInputKey}
                            type="file" 
                            className="form-control" 
                            accept=" application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={handleFileChange} 
                        />
                        <div align="right" className="mt-2">
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                children={"Upload File"}
                            />
                        </div>
                    </form>
                </div>
                <div style={{ flex: 1 }}>
                    <h6 style={{ fontWeight: 600, fontSize: '14px', marginBottom: '12px' }}>Bulk Insert Password</h6>
                    <form onSubmit={(e) => {
                        e.preventDefault()
                        postBulkPassword(() => getUsers(page))
                    }}>
                        <input
                            key={fileInputKey}
                            type="file" 
                            className="form-control" 
                            accept=" application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            onChange={handleFileChange} 
                        />
                        <div align="right" className="mt-2">
                            <ActionButtonGradient
                                type="submit"
                                variant="primary"
                                children={"Upload File"}
                            />
                        </div>
                    </form>
                </div>
            </div>
            {
                logs && 
                <div className="logs" style={{backgroundColor: "#e5eac3", borderColor: "#edf2ad"}}>
                    <p>The following NIK has an error on the column data. Please double check the excel file that you submitted:</p>
                    {
                        logs.map((l) => (
                            <>
                                <p>{l}</p>
                            </>
                        ))
                    }
                </div>
            }
            <div className="table-responsive mt-3">
                <Input 
                    className="mb-2" 
                    placeholder="Search by user name/nik" 
                    allowClear 
                    onChange={setFilterNameUser}
                    prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                    style={{ fontSize: '16px' }}
                />
                <table className="table align-items-center">
                    <thead>
                        <tr>
                            <th scope="col">NIK</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Position</th>
                            <th scope="col">Role</th>
                            <th scope="col">Business Unit</th>
                            <th scope="col">Department</th>
                            <th scope="col">Last Login</th>
                            <th scope="col" style={{width: '5%'}}></th>
                            <th scope="col" style={{width: '5%'}}></th>
                            <th scope="col" style={{width: '5%'}}></th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        payload && payload.map((data) => (
                            <tr key={data.ID}>
                                <td>{data.Nik}</td>
                                <td>{data.Name}</td>
                                <td>{data.Email}</td>
                                <td>{data.Position}</td>
                                <td>
                                    {data.Roles.map((role, index) => (
                                        <span key={index}>{role.Name}, </span>
                                    ))}
                                </td>
                                <td>{data.BusinessUnit.Name}</td>
                                <td>{data.Department}</td>
                                <td>{new Date(data.LastLogin).toString()}</td>
                                <td>
                                    <button 
                                        className="btn" 
                                        onClick={() => navigate(`/user-management/user-form/${data.ID}`)}    
                                        title="edit user"
                                        style={{
                                            padding: '8px 12px',
                                            borderRadius: '5px',
                                            border: '1px solid #02B4CC',
                                            backgroundColor: 'transparent',
                                            color: '#02B4CC',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#02B4CC';
                                            e.currentTarget.style.color = 'white';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.color = '#02B4CC';
                                        }}
                                    >
                                        <BsPencilSquare/>
                                    </button>
                                </td>
                                <td>
                                    <button 
                                        className="btn" 
                                        onClick={() => {
                                            handleShow()
                                            setDeleteID(data.ID)
                                            setName(data.Name)
                                        }}   
                                        title="delete user"
                                        style={{
                                            padding: '8px 12px',
                                            borderRadius: '5px',
                                            border: '1px solid #dc3545',
                                            backgroundColor: 'transparent',
                                            color: '#dc3545',
                                            cursor: 'pointer',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = '#dc3545';
                                            e.currentTarget.style.color = 'white';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = 'transparent';
                                            e.currentTarget.style.color = '#dc3545';
                                        }}
                                    >
                                        <BsFillTrashFill/>
                                    </button>
                                </td>
                                
                                <td>
                                    {
                                        data.GeneratePassword ? <></>: 
                                        <>
                                            <button 
                                                className="btn" 
                                                onClick={() => generatePassword(data.ID, () => getUsers(page))}   
                                                title="generate password"
                                                style={{
                                                    padding: '8px 12px',
                                                    borderRadius: '5px',
                                                    border: '1px solid #198754',
                                                    backgroundColor: 'transparent',
                                                    color: '#198754',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = '#198754';
                                                    e.currentTarget.style.color = 'white';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = 'transparent';
                                                    e.currentTarget.style.color = '#198754';
                                                }}
                                            >
                                                <MdOutlinePassword/>
                                            </button>
                                        </>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
            <div align="right">
                <Select
                    style={{marginLeft: "0.5rem"}}
                    defaultValue={10}
                    options={limitOptions}
                    onChange={(e) => setFilterLimit(e)}
                />
            </div>
            <div className="table-responsive">
                <PaginationComponent
                    current={page}
                    totalPages={totalPage}
                    navigate={changePage}
                />
            </div>
            <DeleteModal 
                show={show} 
                handleClose={handleClose} 
                handleOk={async () => {
                    await deleteUser(deleteID, () => getUsers(page))
                    handleClose()
                }} 
                title={userName}
            />
        </div>
    )
}

export default ListUser